// TODO(Smári): Get this data straight from Kappi.
export const RTC_MIN_BROADCAST_LENGTH: number = 30;
export const RTC_MAX_BROADCAST_LENGTH: number = 360;
